export default "__VITE_ASSET__Cb83Dpaq__"